import React, { useContext, useState, useEffect } from 'react'
import { Context } from "../../../Context";
import { AddPublicityView, AddPublicityDataView, AddPublicityCatalogView } from "../../views";
import { SimpleLoading, ModalUtil } from "../../pures";
import { PublicityService } from "../../../services";
import { AddPublicityIconFirst, AddPublicityIconSecond } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom'


const AddPublicityAction = (props) => {
  const { t } = props
  const { t: translModal } = useTranslation('publicity', { keyPrefix: 'modal' })
  const { t: transl } = useTranslation('publicity', { keyPrefix: 'publicityAddValidations' })
  const apiUrl = process.env.REACT_APP_ETICKET_API;
  const publicityService = new PublicityService(apiUrl)
  const token = JSON.parse(localStorage.getItem('token')).accessToken

  const [initialLoading, setInitialLoading] = useState(false)
  const [step, setStep] = useState(true)
  const [catalogInsert, setCatalogInsert] = useState([])
  const modalUtil = new ModalUtil()
  const history = useHistory()

  //first data
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [url, setUrl] = useState('')
  const [endDate, setEndDate] = useState('')
  const [description, setDescription] = useState('')
  const [image, setImage] = useState(null)
  const [imageSrc, setImageSrc] = useState(null);

  const handleImageUpload = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageSrc(null);
    }
  };

  //second data
  const [consumerPreferencesSelected, setConsumerPreferencesSelected] = useState([])
  const [gendersSelected, setGendersSelected] = useState([])
  const [agesSelected, setAgesSelected] = useState({ start: 10, end: 80 })
  const [branchOfficesSelected, setBranchOfficesSelected] = useState([])

  const sendData = async () => {
    modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

    try {
      const consumerPreferencesIds = consumerPreferencesSelected.map(({ id }) => id)
      const branchOfficesIds = branchOfficesSelected.map(({ id }) => id)
      const genderIds = gendersSelected.map((genderToShow) => {
        const genderObject = catalogInsert.gender.find((gendersSelected) => gendersSelected.name === genderToShow)
        return genderObject.id
      })

      let newPublicityData = new FormData();
      newPublicityData.append("name", name);
      newPublicityData.append("description", description);
      newPublicityData.append("minAge", agesSelected.start);
      newPublicityData.append("maxAge", agesSelected.end);
      newPublicityData.append("startDate", startDate);
      newPublicityData.append("endDate", endDate);
      newPublicityData.append("url", url);
      newPublicityData.append("image", image);
      newPublicityData.append("consumerPreferencesIds", JSON.stringify(consumerPreferencesIds));
      newPublicityData.append("genderIds", JSON.stringify(genderIds));
      newPublicityData.append("branchOfficeIds", JSON.stringify(branchOfficesIds));

      const newPublicity = await publicityService.setPublicity(newPublicityData, token)
      if (newPublicity && newPublicity.data && Number(newPublicity.statusCode) === 200) {
        modalUtil.showModal('success', translModal('successAdd'), t("modal.pure.title.success"), () => history.push('/publicity'))
      } else {
        modalUtil.showModal('error', translModal('errorAdd'), t("modal.pure.title.error"))
      }
    } catch (error) {
      modalUtil.showModal('error', translModal('errorAdd'), t("modal.pure.title.error"))
    }
  }

  const steps = [
    {
      image: AddPublicityIconFirst,
      title: 'Datos',
      next: 'Continuar',
      back: 'Salir',
    },
    {
      image: AddPublicityIconSecond,
      title: 'Documentos',
      next: 'Finalizar',
      back: 'Regresar',
    },
  ]

  useEffect(() => {
    getCatalogInsert()
  }, [])

  const getCatalogInsert = async () => {
    try {
      const catalogInsert = await publicityService.getCatalogInsert(token)
      setCatalogInsert(catalogInsert)
      setInitialLoading(false)
    } catch (error) {
      props.setShowError(true)
      setInitialLoading(false)
    }
  }

  const isValidInfoPage = (page) => {
    try {
      const tableValidations = {
        1: validationsFirstPage,
        2: validationsSecondPage
      }

      tableValidations[page]()
      return true
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
      return false
    }
  }

  const validationsFirstPage = () => {
    if ([name, startDate, url, endDate, description, image, imageSrc].some(field => !field)) throw new Error(transl('validationsInputFirstPage'))
    // if (!name || !startDate || !url || !endDate || !description || !image || !imageSrc) throw new Error(transl('validationsInputFirstPage'))
    if (startDate > endDate) throw new Error(transl('datesValidation'))
  }

  const validationsSecondPage = () => {
    if (!consumerPreferencesSelected.length) throw new Error(transl('preferencesValidation'))
    if (!gendersSelected.length) throw new Error(transl('genderValidation'))
    if (agesSelected.start > agesSelected.end) throw new Error(transl('agesValidation'))
    if (!branchOfficesSelected.length) throw new Error(transl('branchOfficeValidation'))
  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> : (
            <AddPublicityView
              {...props}
              steps={steps}
              catalogInsert={catalogInsert}
              name={name}
              setName={setName}
              startDate={startDate}
              setStartDate={setStartDate}
              url={url}
              setUrl={setUrl}
              endDate={endDate}
              setEndDate={setEndDate}
              description={description}
              setDescription={setDescription}
              image={image}
              setImage={setImage}
              consumerPreferencesSelected={consumerPreferencesSelected}
              setConsumerPreferencesSelected={setConsumerPreferencesSelected}
              gendersSelected={gendersSelected}
              setGendersSelected={setGendersSelected}
              agesSelected={agesSelected}
              setAgesSelected={setAgesSelected}
              branchOfficesSelected={branchOfficesSelected}
              setBranchOfficesSelected={setBranchOfficesSelected}
              sendData={sendData}
              handleImageUpload={handleImageUpload}
              imageSrc={imageSrc}
              isValidInfoPage={isValidInfoPage}
            >
            </AddPublicityView >
          )
      }
    </>
  )
}

function AddPublicityActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <AddPublicityAction {...props} t={t} setShowError={setShowError} />
  );
}

export { AddPublicityActionContainer as default };